<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header [title]="t('dashboard.openTasks.title')" routerLink="/app/processes/tasks">
        <span class="row"
          >{{ t("dashboard.openTasks.total") }}
          @defer (when openTaskMetric()) {
            {{ openTaskMetric().taskCounts }}
          } @placeholder {
            <p-skeleton shape="circle" size="1.5rem" />
          }
        </span>
      </new-ui-dashboard-card-header>
    </ng-template>

    @defer (when openTaskMetric()) {
      @if (openTaskMetric().tasks?.length > 0) {
        <new-ui-dashboard-list [values]="openTaskMetric().tasks" />
      } @else {
        <ui-emptystate
          class="py-[3%]"
          image="/assets/layout/images/new-ui/goal.png"
          [caption]="settings.isCandidate ? t('emptystate.candidateTasks.title') : t('emptystate.tasks.title')"
          [description]="
            settings.isCandidate ? t('emptystate.candidateTasks.description') : t('emptystate.tasks.description')
          "
        />
      }
    } @placeholder {
      <ul class="col gap-4 p-0 pr-2">
        @for (item of [1, 2, 3]; track item) {
          <li class="flex flex-col mobile:flex-row gap-4 p-2 border border-surface-border rounded-lg shadow-sm">
            <div class="basis-1/2 row gap-2">
              <p-skeleton shape="circle" size="1.25rem" />
              <p-skeleton class="h-5 w-40" />
            </div>
            <div class="basis-1/2 row gap-2">
              <p-skeleton class="h-5 w-24" />
            </div>
          </li>
        }
      </ul>
    }
  </new-ui-dashboard-card>
</ng-container>
